import { Injectable } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { SelectDialogComponent } from 'app/shared/select-dialog/select-dialog.component';
import { TranslateSharedModule } from 'app/shared/translate/translate.module';
import * as fileSaver from 'file-saver';
import { Observable } from 'rxjs/Observable';
import Swal from 'sweetalert2';
import { ToastComponent } from './toast/toast.component';

declare const $: any;

@Injectable()
export class Global {

    private static loadingText = 'Aguarde...';
    private static _loadQueue = [];

    public companies;
    public dialogs = {};


    constructor(
        public dialog: MatDialog,
        public router: Router,
        private snackBar: MatSnackBar,
        private translateService: TranslateSharedModule
    ) {

    }

    public set loading(value: boolean) {
        if (value === false) {
            Global._loadQueue.length = 0;
        }
    }

    public get loading() {
        return !!Global._loadQueue.length;
    }

    public set loadingText(value: string) {
        Global.loadingText = value;
    }

    public get loadingText() {
        return Global.loadingText;
    }

    public openHub(hubPath) {
        window['loading'] = true;
        setTimeout(() => {
            this.router.navigate(['/-' + hubPath]);
        }, 100);
    }

    public loggedUser() {
        let user: any = sessionStorage.getItem('loggedUser');
        if (user) {
            user = JSON.parse(user).data;
            return user;
        }
        return null;
    }

    public client() {
        const client = sessionStorage.getItem('client');
        return client;
    }

    public download(filename, data, fileProperties = { type: 'application/ms-excel' }) {
        this.startLoading('Gerando arquivo...');
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([(data)], fileProperties);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob, filename);
            return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const downloadURL = URL.createObjectURL(newBlob);
        fileSaver.saveAs(downloadURL, filename);
        this.stopLoading();
    }

    public isEnabled(tag) {
        const user = this.loggedUser();

        let r = user.resource.find(res => res.tag == tag);
        if (r) {
            return r.enabled;
        }

        r = user.resource_sub.find(res => res.tag == tag);
        if (r) {
            return r.enabled;
        }

        return false;
    }

    public searchData(searchParams) {
        const dialogOptions = {
            width: '550px',
            data: searchParams
        };

        if (searchParams.dialogWidth) {
            dialogOptions.width = searchParams.dialogWidth;
        }

        const dialog = this.dialog.open(SelectDialogComponent, dialogOptions);


        return dialog.afterClosed();
    }

    public toast(message: string, title: string, type: string, options: any): Observable<any>;
    public toast(message: string, title: string, type: string): any;
    public toast(message: string, title: string): any;
    public toast(message: string): any;
    public toast(paramsA: any, paramsB: any = null, paramsC: any = null, paramsD: any = null): any {
        this.snackBar.openFromComponent(ToastComponent, {
            panelClass: [`admin-toast-box`],
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration: 4000,
            data: {
                message: paramsA,
                title: paramsB,
                type: paramsC,
                ...paramsD
            }
        });

        return 0;
    }

    public showNotification(message, type = 'success', icon = 'notifications', position = 'top-right', delay = 3000) {
        // const type = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
        const pos: any = position.split('-');

        if (type === 'error') {
            type = 'danger';
        }
        else if (type === 'warning') {
            type = 'warn';
        }

        // $.notify({
        //     icon: icon,
        //     message: message
        // }, {
        //     type: type,
        //     delay: delay,
        //     placement: {
        //         from: pos[0],
        //         align: pos[1]
        //     }
        // });
        this.toast(message, '', type, {
            verticalPosition: pos[0],
            horizontalPosition: pos[1],
            delay
        });
    }

    public hasCompanies() {
        if (this.companies) {
            return true;
        }
        else {
            const companies = sessionStorage.getItem('companies');
            if (companies) {
                this.companies = JSON.parse(companies);
                return true;
            }
            return false;
        }
    }

    public async startLoading(message = null) {
        if (message == null) {
            message = await this.translateService.showTranslator('Wait') + '...';
        }
        this.loadingText = message;
        Global._loadQueue.push('');
    }

    public async stopLoading() {
        Global._loadQueue.pop();
        this.loadingText = await this.translateService.showTranslator('Wait') + '...';
    }

    public arrayEquals(a, b) {
        if (a == b) {
            return true;
        }

        if (!a) {
            if (!b) {
                return true;
            }
            else {
                return false;
            }
        }

        if (!b) {
            if (!a) {
                return true;
            }
            else {
                return false;
            }
        }

        if (a.length == b.length) {
            for (const i of a) {
                if (b.indexOf(i) < 0) {
                    return false;
                }
            }
            for (const i of b) {
                if (a.indexOf(i) < 0) {
                    return false;
                }
            }
            return true;
        }

        return false;
    }

    public alert(title, message?, type?) {
        return Swal.fire(title, message, type);
    }

    public swal(options) {
        return Swal.fire(options);
    }

    public dialogRef(dialogRef) {
        return this.dialogs[dialogRef];
    }

    public dialogOpen(dialog, config = {}, dialogRef = '') {
        if (dialogRef == '') {
            this.dialog.open(dialog, config);
        }
        else {
            this.dialogs[dialogRef] = this.dialog.open(dialog, config);
        }
    }

    public dialogClose(dialogRef, data = null) {
        this.dialogs[dialogRef].close(data);
    }

    public getLanguage() {
        const language = localStorage.getItem('language');
        return (language) ? language : 'pt-br';
    }

    public getIconByMime(mimeType) {
        // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
        const icon_classes = {
            // Media
            image: 'fa-file-image-o',
            audio: 'fa-file-audio-o',
            video: 'fa-file-video-o',
            // Documents
            'application/pdf': 'fa-file-pdf-o',
            'application/msword': 'fa-file-word-o',
            'application/vnd.ms-word': 'fa-file-word-o',
            'application/vnd.oasis.opendocument.text': 'fa-file-word-o',
            'application/vnd.openxmlformats-officedocument.wordprocessingml':
                'fa-file-word-o',
            'application/vnd.ms-excel': 'fa-file-excel-o',
            'application/vnd.openxmlformats-officedocument.spreadsheetml':
                'fa-file-excel-o',
            'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel-o',
            'application/vnd.ms-powerpoint': 'fa-file-powerpoint-o',
            'application/vnd.openxmlformats-officedocument.presentationml':
                'fa-file-powerpoint-o',
            'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint-o',
            'text/plain': 'fa-file-text-o',
            'text/html': 'fa-file-code-o',
            'application/json': 'fa-file-code-o',
            // Archives
            'application/gzip': 'fa-file-archive-o',
            'application/zip': 'fa-file-archive-o'
        };

        for (const key in icon_classes) {
            if (icon_classes.hasOwnProperty(key)) {
                if (mimeType.search(key) === 0) {
                    // Found it
                    return icon_classes[key];
                }
            } else {
                return 'fa-file-o';
            }
        }
    }

    public getPlatform() {
        let config: any = localStorage.getItem('config_color');
        if (config) {
            config = JSON.parse(config);
            if (config.config.template.platform_type) {
                return config.config.template.platform_type;
            }

            return false;
        }

        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/@core/lib/global.ts